<template>
  <div>
    <servicos-realizados-table ref="servicosRealizadosTableRef"></servicos-realizados-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

const servicosRealizadosTableRef = ref<DataTableInstance | null>(null);

const loadData = async () => {
  if (servicosRealizadosTableRef.value) {
    await servicosRealizadosTableRef.value.loadData();
  }
};

onMounted(() => log('ServicosRealizadosPage', 'mounted', 'Component mounted'));
onBeforeUnmount(() => log('ServicosRealizadosPage', 'beforeUnmount', 'Cleaning up'));

defineExpose({ loadData });
</script>
